import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Plus, Trash2, Edit } from "lucide-react";

export default function EmployeeListPage() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEmployees = async () => {
    try {
      const res = await api.get("/employee");
      setEmployees(res.data || []);
    } catch {
      toast.error("Çalışanlar yüklenemedi");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Bu çalışanı silmek istediğinize emin misiniz?"))
      return;
    api
      .delete(`/employee/${id}`)
      .then(() => {
        toast.success("Çalışan silindi");
        fetchEmployees();
      })
      .catch(() => toast.error("Silme başarısız"));
  };

  if (loading)
    return (
      <div className="page-loading">
        <div className="loading-spinner" />
        <p>Yükleniyor...</p>
      </div>
    );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Ekip Üyeleri</h2>
          <p className="page-subtitle">{employees.length} çalışan</p>
        </div>
        <Link to="/add-employee" className="btn btn-primary">
          <Plus size={18} /> Yeni Çalışan
        </Link>
      </div>

      <div className="content-card no-padding">
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Görsel</th>
                <th>Ad Soyad</th>
                <th>Unvan</th>
                <th>Telefon</th>
                <th>E-posta</th>
                <th>Sıra</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => (
                <tr key={emp.employeeId}>
                  <td>
                    {emp.imagePath ? (
                      <img
                        src={`${process.env.REACT_APP_UPLOAD_URL}/${emp.imagePath}`}
                        alt={emp.fullName}
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          background: "var(--primary-light)",
                          color: "var(--primary)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 600,
                          fontSize: 14,
                        }}
                      >
                        {emp.fullName?.charAt(0)}
                      </div>
                    )}
                  </td>
                  <td className="fw-medium">{emp.fullName}</td>
                  <td>{emp.titleTr}</td>
                  <td>{emp.phone}</td>
                  <td>{emp.email}</td>
                  <td>{emp.sortOrder}</td>
                  <td>
                    <span
                      className={`status-badge ${emp.isActive ? "active" : "inactive"}`}
                    >
                      {emp.isActive ? "Aktif" : "Pasif"}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <Link
                        to={`/edit-employee/${emp.slug}`}
                        className="btn-icon edit"
                        title="Düzenle"
                      >
                        <Edit size={16} />
                      </Link>
                      <button
                        onClick={() => handleDelete(emp.employeeId)}
                        className="btn-icon delete"
                        title="Sil"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {employees.length === 0 && (
          <div className="empty-state">
            <p>Henüz çalışan eklenmemiş</p>
          </div>
        )}
      </div>
    </div>
  );
}
